import {
  ActiveCodeStatus,
  ApprovalStatus,
  BookAppendixItemType,
  ExamErrorCode,
  ExamPartErrorCode,
  ExamPartQuestionErrorCode,
  ExamResponseStatus,
  ExamType,
  GameStatus,
  GameType,
  LectureStatus,
  LectureType,
  QuestionType,
  TheoryStatus,
  TheoryType,
  ThinkingLevel,
} from '../model/enum';
import { LearningAssetStatus, LearningBookStatus } from '../model/request';

type EnumMapper<T> = {
  label: string;
  value: T;
}[];

export const approvalStatusList: EnumMapper<ApprovalStatus> = [
  {
    label: 'Đang kiểm duyệt',
    value: 'PENDING',
  },
  {
    label: 'Đã kiểm duyệt',
    value: 'APPROVED',
  },
  {
    label: 'Đã từ chối',
    value: 'DECLINED',
  },
];

export const examTypeList: EnumMapper<ExamType> = [
  {
    label: 'Đề thi chính thức',
    value: 'OFFICIAL',
  },
  {
    label: 'Đề thi thử',
    value: 'SYSTEM',
  },
];

export const questionTypeList: EnumMapper<QuestionType> = [
  {
    label: 'Nhóm câu hỏi',
    value: 'GROUPED_QUESTION',
  },
  {
    label: 'Câu trắc nghiệm 1 đáp án',
    value: 'ONE_CHOICE_QUESTION',
  },
  {
    label: 'Câu hỏi trả lời ngắn',
    value: 'SHORT_QUESTION',
  },
  {
    label: 'Câu hỏi đúng sai',
    value: 'YES_NO_QUESTION',
  },
  {
    label: 'Câu hỏi tự luận',
    value: 'TOPIC_QUESTION',
  },
];

export const thinkingLevelList: EnumMapper<ThinkingLevel> = [
  {
    label: 'Nhận biết',
    value: 'KNOWING',
  },
  {
    label: 'Thông hiểu',
    value: 'UNDERSTANDING',
  },
  {
    label: 'Vận dụng',
    value: 'APPLYING',
  },
  {
    label: 'Vận dụng cao',
    value: 'HIGHLY_APPLYING',
  },
];

export const examResponseStatusList: EnumMapper<ExamResponseStatus> = [
  {
    label: 'Hoàn thành',
    value: 'COMPLETED',
  },
  {
    label: 'Đang làm',
    value: 'DOING',
  },
  {
    label: 'Chưa làm',
    value: 'NO_HISTORY',
  },
];

export const learningBookStatusList: EnumMapper<LearningBookStatus> = [
  {
    label: 'Hoạt động',
    value: 'ACTIVE',
  },
];

export const learningAssetStatusList: EnumMapper<LearningAssetStatus> = [
  {
    label: 'Hoạt động',
    value: 'ACTIVE',
  },
];

export const getEnumLabel = <T>(value: T, enumMap: EnumMapper<T>) => {
  return enumMap.find((enumItem) => enumItem.value === value)?.label || '';
};

export const theoryStatusList: EnumMapper<TheoryStatus> = [
  {
    label: 'Hoạt động',
    value: 'ACTIVE',
  },
  {
    label: 'Không hoạt động',
    value: 'INACTIVE',
  },
];

export const theoryTypeList: EnumMapper<TheoryType> = [
  {
    label: 'Cơ bản',
    value: 'BASIC',
  },
  {
    label: 'Nâng cao',
    value: 'ADVANCED',
  },
];

export const lectureStatusList: EnumMapper<LectureStatus> = [
  {
    label: 'Hoạt động',
    value: 'ACTIVE',
  },
  {
    label: 'Không hoạt động',
    value: 'INACTIVE',
  },
];

export const lectureTypeList: EnumMapper<LectureType> = [
  {
    value: 'CTST',
    label: 'Chân trời sáng tạo',
  },
  {
    value: 'KNTT',
    label: 'Kết nối tri thức',
  },
];

export const gameTypeList: EnumMapper<GameType> = [
  {
    label: 'Chính thức',
    value: 'OFFICIAL',
  },
  {
    label: 'KHông chính thức',
    value: 'UNOFFICIAL',
  },
];

export const gameStatusList: EnumMapper<GameStatus> = [
  {
    label: 'Hoạt động',
    value: 'ACTIVE',
  },
  {
    label: 'Không hoạt động',
    value: 'DEACTIVE',
  },
];

export const bookAppendixItemTypeList: EnumMapper<BookAppendixItemType> = [
  {
    label: 'Lý thuyết',
    value: 'THEORY',
  },
  {
    label: 'Bài giảng',
    value: 'LECTURE',
  },
  {
    label: 'Dạng bài tập',
    value: 'EXERCISE_FORMAT',
  },
  {
    label: 'Đề kiểm tra',
    value: 'EXAM',
  },
  {
    label: 'Đề tự luyện',
    value: 'PRACTICE',
  },
];

export const examErrorCodeList: EnumMapper<ExamErrorCode> = [
  {
    label: 'Thiếu tên đề kiểm tra',
    value: 'MISSING_EXAM_NAME',
  },
  {
    label: 'Thiếu thời gian làm bài',
    value: 'MISSING_DURATION',
  },
  {
    label: 'Thời gian làm bài phải là số tự nhiên',
    value: 'DURATION_SHOULD_POSITIVE',
  },
  {
    label: 'Thiếu số điểm cần sử dụng',
    value: 'MISSING_REQUIRED_TICKET_COUNT',
  },
  {
    label: 'Số điểm cần sử dụng phải là số tự nhiên',
    value: 'REQUIRED_TICKET_COUNT_SHOULD_POSITIVE',
  },
  {
    label: 'Thiếu môn học',
    value: 'MISSING_SUBJECT',
  },
  {
    label: 'Thiếu phần thi so với mẫu đề',
    value: 'MISSING_EXAM_PART',
  },
  {
    label: 'Thừa phần thi so với mẫu đề',
    value: 'EXCESS_EXAM_PART',
  },
];

export const examPartErrorCodeList: EnumMapper<ExamPartErrorCode> = [
  {
    label: 'Thiếu tên phần thi',
    value: 'MISSING_EXAM_PART_NAME',
  },
  {
    label: 'Thiếu câu hỏi so với mẫu đề',
    value: 'MISSING_QUESTION',
  },
  {
    label: 'Thừa câu hỏi so với mẫu đề',
    value: 'EXCESS_QUESTION',
  },
];

export const examPartQuestionErrorCodeList: EnumMapper<ExamPartQuestionErrorCode> = [
  {
    label: 'Thiếu điểm',
    value: 'MISSING_MARK',
  },
  {
    label: 'Điểm phải là số dương',
    value: 'MARK_SHOULD_POSITIVE',
  },
  {
    label: 'Thiếu trọng số',
    value: 'MISSING_WEIGHT',
  },
  {
    label: 'Trọng số phải là số tự nhiên',
    value: 'WEIGHT_SHOULD_POSITIVE',
  },
  {
    label: 'Thiếu đề bài',
    value: 'MISSING_TOPIC',
  },
  {
    label: 'Thiếu loại câu hỏi',
    value: 'MISSING_TYPE',
  },
  {
    label: 'Thiếu đáp án đúng',
    value: 'MISSING_RIGHT_ANSWER',
  },
  {
    label: 'Chưa đủ số lượng đáp án',
    value: 'MISSING_QUESTION_DETAIL',
  },
  {
    label: 'Thừa số lượng đáp án',
    value: 'EXCESS_QUESTION_DETAIL',
  },
  {
    label: 'Thiếu câu hỏi con',
    value: 'MISSING_CHILDREN',
  },
  {
    label: 'Thừa câu hỏi con',
    value: 'EXCESS_CHILDREN',
  },
  {
    label: 'Câu hỏi có loại sai so với mẫu đề',
    value: 'WRONG_TYPE_WITH_EXAM_TEMPLATE',
  },
  {
    label: 'Thiếu mã câu hỏi',
    value: 'MISSING_QUESTION_CODE',
  },
  {
    label: 'Thiếu dạng bài tập',
    value: 'MISSING_EXERCISE_FORMAT',
  },
  {
    label: 'Thiếu mức độ thông thạo',
    value: 'MISSING_THINKING_LEVEL',
  },
  {
    label: 'Thiếu năng lực',
    value: 'MISSING_SKILL_TYPE',
  },
];

export const errorCodeList: EnumMapper<ExamErrorCode | ExamPartErrorCode | ExamPartQuestionErrorCode> = [
  ...examErrorCodeList,
  ...examPartErrorCodeList,
  ...examPartQuestionErrorCodeList,
];

export const activeCodeStatusList: EnumMapper<ActiveCodeStatus> = [
  {
    label: 'Chưa kích hoạt',
    value: 'INACTIVE',
  },
  {
    label: 'Đã kích hoạt',
    value: 'ACTIVE',
  },
  {
    label: 'Đã vô hiệu hóa',
    value: 'DISABLED',
  },
];
